import React from 'react';
import Stars from './Stars';
import { Link } from 'react-router-dom';
const MovieCard = ({movie, stars}) => {
    const [preferidos] = React.useState(() => {
        const localList = localStorage.getItem('preferidos')
        return localList ? JSON.parse(localList) : []
    });
    React.useEffect(()=>{
        window.localStorage.setItem('preferidos', JSON.stringify(preferidos))
    },[preferidos])
    return (
            <div className="movie">
                <div className="movie__wrapper">
                    <Link to={`/movie/${movie.id}`}>
                        <img src={movie.poster} alt="Filme ou série" />                
                    </Link>
                </div>
                <h3>{movie.nome}</h3>
                {stars===false? '' : <Stars n={movie.stars}></Stars>}
            </div>
    )
}

export default MovieCard
